<mat-card appearance="outlined" class="widget">
    <mat-card-title class="card-title">Foton</mat-card-title>
    <mat-card-content>
        <img class="todays-picture" src={{todays_picture?.thumb}} [routerLink]="['/gallery', todays_picture?.url]" />
    </mat-card-content>
</mat-card>
    